import React from 'react'

import { ContentStateProperty, FieldProps } from '../../../../../../../@types/types'
import { ConstructionScreenValidationResult } from '../../../../../../../@types/validation-types'
import { TextInput } from '../../../../../../common/inputs/textInput/TextInput'

export interface ThermalCharacteristicProps extends Omit<FieldProps<ConstructionScreenValidationResult>, 'onChange'> {
  validators: ConstructionScreenValidationResult
  thermalCharacteristicInputLabel: React.JSX.Element
  onEnergyCertificateChange: (field: ContentStateProperty, value: string | boolean | undefined) => void
}

const ThermalCharacteristicField: React.FC<ThermalCharacteristicProps> = ({
  insertionData,
  validators,
  thermalCharacteristicInputLabel,
  onEnergyCertificateChange,
  wrapperClassName,
}) => (
  <div className={wrapperClassName}>
    <TextInput
      id='thermal-characteristic'
      propertyName='thermalCharacteristic'
      value={insertionData.thermalCharacteristic}
      label={thermalCharacteristicInputLabel}
      errors={validators.thermalCharacteristic ?? []}
      affixRight='unit'
      unitRight='kilowattHour'
      placeholder=''
      maxLength={8}
      doOnFieldChange={(field, value) => onEnergyCertificateChange(field, value)}
    />
  </div>
)

export default ThermalCharacteristicField
